'use client';

import { useEffect, useRef } from 'react';
import { gtmCurrentWishlist } from 'modules/gtm/modules/sections/wishlist/wishlist';
import { CurrentWishlist } from 'modules/gtm/modules/types';
import { divide } from 'modules/math';
import { usePathname } from 'modules/next/hooks';
import { WishList } from 'modules/shop/wishlist/types';
import { useWishlist } from 'modules/shop/wishlist/useWishlist';

export const parseWishlist = (wishlist: WishList) => {
  return wishlist.items.reduce(
    (acc, el) => {
      if (el.adaptedProduct) {
        const { referenceKey, price, name } = el.adaptedProduct;
        const priceWithTax = divide(price.withTax as number, 100);

        return {
          matsids: [...acc.matsids, referenceKey],
          products: [
            ...acc.products,
            {
              name: name,
              product_id: referenceKey,
              price: priceWithTax,
            },
          ],
        };
      }

      return acc;
    },
    {
      matsids: [],
      products: [],
    } as CurrentWishlist,
  );
};

export const useGTMCurrentWishlist = () => {
  const { wishlist } = useWishlist();
  const pathname = usePathname();
  const lastPathname = useRef('');

  useEffect(() => {
    if (wishlist && lastPathname.current !== pathname) {
      const currentWishlist = parseWishlist(wishlist);
      gtmCurrentWishlist(wishlist.items.length ? currentWishlist : null);

      lastPathname.current = pathname;
    }
  }, [pathname, wishlist]);
};
